import { CopyButton } from './CopyButton.js';

export interface CopyableCodeProps {
  /** The exact text copied to the clipboard. */
  value: string;
  /** What to show inside the code (defaults to `value`) — e.g. a masked prefix. */
  display?: string;
  /** Optional leading label. */
  label?: string;
  /** Truncate (single line) instead of wrapping/breaking. */
  truncate?: boolean;
  className?: string;
  /** Subject for the copy button's tooltip/aria (defaults to `label`). */
  subject?: string;
}

/**
 * A mono `<code>` value with a click-to-copy button — the label/code/copy row
 * primitive. Generalizes the ad-hoc "handoff"/"DNS" rows across the admin pages.
 */
export function CopyableCode({ value, display, label, truncate, className, subject }: CopyableCodeProps): JSX.Element {
  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      {label && <span className="shrink-0 text-fg-muted">{label}</span>}
      <code
        dir="ltr"
        className={`min-w-0 flex-1 select-all rounded border border-border bg-bg px-2 py-1 text-start font-mono text-xs ${truncate ? 'truncate' : 'break-all'}`}
      >
        {display ?? value}
      </code>
      <CopyButton value={value} subject={subject ?? label} />
    </div>
  );
}
